import { AddAddressComponent } from './addAddress.component';
import { AddressAuthenticatedComponent } from './address_authenticated.component';
import { AddressGuestComponent } from './address_guest.component';
import { AddressCardComponent } from './addressCard.component';
import { AddressPickerComponent } from './addressPicker.component';
import { AddressSuggestionsComponent } from './addressSuggestions.component';

import { AddressService } from './address.service';

import './address.scss';

export const AddressModule = angular
    .module('oo.checkout.checkoutSteps.address', [])
    .component('addAddress', AddAddressComponent)
    .component('addressPicker', AddressPickerComponent)
    .component('addressAuthenticated', AddressAuthenticatedComponent)
    .component('addressGuest', AddressGuestComponent)
    .component('addressCard', AddressCardComponent)
    .component('addressSuggestions', AddressSuggestionsComponent)

    .service('addressService', AddressService)
    .name;
